import React from 'react';
import { Container, Col, Row, Breadcrumb } from "react-bootstrap";
import './assets/styles/_index.scss';

const PropertyBreadcrumb = (props) => {

    const handleBack = () => typeof window !== "undefined" && window.history.back();

    return (
        <section className="property-breadcrumb-wrapper">
            <Container>
                <Row>
                    <Col>
                        <Breadcrumb className="property-breadcrumb d-md-flex align-items-center d-none">
                            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                            {/* <Breadcrumb.Item href="#">Services</Breadcrumb.Item> */}
                            {/* <Breadcrumb.Item href={props?.propertyData?.search_type === "sales" ? "/properties/for-sale/" : "/properties/for-rent/"}>{props?.propertyData?.search_type === "sales" ? "Buy" : "Rent"}</Breadcrumb.Item> */}
                            {
                                props.holidayHomes === "holiday-homes" ?
                                <Breadcrumb.Item href={props?.propertyData?.search_type === "sales" ? "/holiday-homes/for-sale/in-dubai" : "/holiday-homes/for-rent/in-dubai"}>Holiday Homes {props?.propertyData?.search_type === "sales" ? " for sale " : " for rent "} in Dubai</Breadcrumb.Item>
                                :
                                    props.propertyData?.department === "commercial" ?
                                    <Breadcrumb.Item href={props?.propertyData?.search_type === "sales" ? "/properties/commercial/for-sale/in-dubai" : "/properties/commercial/for-rent/in-dubai"}>Commercial Property {props?.propertyData?.search_type === "sales" ? "for sale" : "for rent"} in Dubai</Breadcrumb.Item>
                                    :
                                    <Breadcrumb.Item href={props?.propertyData?.search_type === "sales" ? "/properties/for-sale/in-dubai" : "/properties/for-rent/in-dubai"}>Property {props?.propertyData?.search_type === "sales" ? "for sale" : "for rent"} in Dubai</Breadcrumb.Item>
                            }
                            <Breadcrumb.Item active>{props?.propertyData?.display_address}</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="d-md-none breadcrumb-back">
                            <a href="javascript:void(0)" onClick={handleBack} className="d-flex align-items-center">
                                <i className="icon icon-search-back"></i> Back to Search Results
                            </a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default PropertyBreadcrumb